import { render, staticRenderFns } from "./AccordionSection.vue?vue&type=template&id=6f798ca1&"
import script from "./AccordionSection.vue?vue&type=script&lang=js&"
export * from "./AccordionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports